import React, { useState, useEffect } from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import Footer from "../components/Footer"
import { Container, CardDeck } from "react-bootstrap"
import Header from "../components/Header"

// import { useStaticQuery } from "gatsby"
import Card from "../components/Card"
import MetaData from "../components/MetaData"

export default function Projects() {
  var [projects, setProjects] = useState([])
  useEffect(() => {
    fetch(
      "https://api.github.com/users/debajitdeb11/repos?per_page=100&type=owner",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(),
      }
    )
      .then(res => res.json())
      .then(r => setProjects(r))
  }, [])

  // const data = useStaticQuery(
  //   graphql`
  //     query MyQuery {
  //       allGithubData {
  //         nodes {
  //           data {
  //             user {
  //               repositories {
  //                 nodes {
  //                   description
  //                   id
  //                   primaryLanguage {
  //                     name
  //                   }
  //                   name
  //                   url
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   `
  // )

  // const repos = data.allGithubData.nodes[0].data.user.repositories.nodes

  return (
    <div>
      <MetaData />
      <Container
        fluid
        style={{
          textAlign: "center",
          padding: "20px",
        }}
      >
        {/* <Container
          style={{
            textAlign: "center",
            padding: "20px",
          }}
        > */}
        <Header />
        {/* </Container> */}

        <CardDeck>
          {Object.entries(projects).map(repo => {
            const project = repo[1]

            if (!project.fork) {
              return (
                <Card
                  key={project.id}
                  name={project.name}
                  url={project.html_url}
                  description={project.description}
                  language={project.language}
                />
              )
            }
          })}

          {/* {repos.map(repo => (
            <Card
              key={repo.id}
              name={repo.name}
              url={repo.url}
              description={repo.description}
              language={
                repo.primaryLanguage != null ? repo.primaryLanguage.name : ""
              }
            />
          ))} */}
        </CardDeck>
      </Container>

      <Footer />
    </div>
  )
}
